<div>
  <ul class="ks-tabs">
    <li *ngFor="let tab of tabs; let i = index" [ngClass]="{'ks-active': i === activeTab}"
        (click)="selectTab(i)">{{tab.header}}</li>
  </ul>
  <ng-content></ng-content>
</div>
